export * from './baChartistChart.component';



// WEBPACK FOOTER //
// ./src/app/theme/components/baChartistChart/index.ts